var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnrampfailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear_5945_359501)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint1_linear_5945_359501)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9992 16.6453C25.7602 16.6453 16.6492 25.7563 16.6492 36.9953C16.6492 48.2343 25.7602 57.3453 36.9992 57.3453C48.2382 57.3453 57.3492 48.2343 57.3492 36.9953C57.3492 25.7563 48.2382 16.6453 36.9992 16.6453ZM12.9492 36.9953C12.9492 23.7129 23.7168 12.9453 36.9992 12.9453C50.2817 12.9453 61.0492 23.7129 61.0492 36.9953C61.0492 50.2778 50.2817 61.0453 36.9992 61.0453C23.7168 61.0453 12.9492 50.2778 12.9492 36.9953Z",
    fill: "#E8584B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7074 28.2872C46.4298 29.0096 46.4298 30.181 45.7074 30.9035L30.9074 45.7035C30.1849 46.4259 29.0135 46.4259 28.2911 45.7035C27.5686 44.981 27.5686 43.8096 28.2911 43.0872L43.0911 28.2872C43.8135 27.5647 44.9849 27.5647 45.7074 28.2872Z",
    fill: "#E8584B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2911 28.2872C29.0135 27.5647 30.1849 27.5647 30.9074 28.2872L45.7074 43.0872C46.4298 43.8096 46.4298 44.981 45.7074 45.7035C44.9849 46.4259 43.8135 46.4259 43.0911 45.7035L28.2911 30.9035C27.5686 30.181 27.5686 29.0096 28.2911 28.2872Z",
    fill: "#E8584B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5945_359501",
    x1: 33.797,
    y1: -7.16129,
    x2: 79.5922,
    y2: 9.19047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EACFA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5945_359501",
    x1: 41.197,
    y1: 80.5645,
    x2: 2.22638,
    y2: 62.9472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAEA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EACFA6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnrampfailed);
export default __webpack_public_path__ + "static/media/onrampfailed.a0409899a4114691b2abf094288c5665.svg";
export { ForwardRef as ReactComponent };